export default __webpack_public_path__ + "static/media/3.f92262a5.jpg";